export const config = {
  LANGUAGE: process.env.LANGUAGE || 'he',
};
